// frontend/src/pages/dashboard/TaskComponents/AuthenticatedImage.js

import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, CircularProgress } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";

const AuthenticatedImage = ({ attachment, style, onError }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchImage = async () => {
      if (!attachment?.id) return;
      try {
        const token = localStorage.getItem('access_token');
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/attachments/${attachment.id}/download`,
          {
            responseType: 'blob',
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        setImageUrl(url);
        setLoading(false);
      } catch (err) {
        console.error('Failed to load image:', err);
        setError(true);
        setLoading(false);
        onError?.(err);
      }
    };
    fetchImage();
    return () => {
      if (imageUrl) URL.revokeObjectURL(imageUrl);
    };
  }, [attachment?.id, onError, imageUrl]);

  if (loading) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#f5f5f5',
        }}
      >
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (error || !imageUrl) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#f5f5f5',
        }}
      >
        <AttachFileIcon color="action" />
      </Box>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={attachment.original_name}
      style={style}
      onError={(e) => {
        e.target.style.display = 'none';
        e.target.nextSibling.style.display = 'flex';
      }}
      loading="lazy"
    />
  );
};

export default AuthenticatedImage;